const EN_US = {
  'cashflowDomain.title': 'Cashflow',

  // Price Audit Landing Page
  'cashflowDomain.priceAudit.title': 'Price audit',
  'cashflowDomain.priceAudit.cashflow.workflow.title': 'New Issues',
  'cashflowDomain.priceAudit.cashflow.escalated.workflow.title': 'New Escalated Issues',
  'cashflowDomain.priceAudit.refresh': 'Refresh',
  'cashflowDomain.priceAudit.startReviewing': 'Start Reviewing',
  'cashflowDomain.priceAudit.startReviewingEscalated': 'Start Reviewing Escalated',
  'cashflowDomain.priceAudit.errorTitle': 'Error',
  'cashflowDomain.priceAudit.errorBodyNoBatch': 'There are no issues to review',
  'cashflowDomain.priceAudit.errorBody.fetch.audit.batch':
    'Failed to fetch the issue. Please try again later.',
  'cashflowDomain.priceAudit.errorBody.submit.review':
    'Failed to submit the review. Please try again later.',
  'cashflowDomain.priceAudit.errorBody.fetch.immutable.item':
    'Failed to fetch the product details. Please try again later.',

  // Price Audit Details Page
  'cashflowDomain.priceAudit.details.page.error.audit.batch.not.found':
    'No issue found: {auditBatchUuid}',
  'cashflowDomain.priceAudit.details.page.error.no.access':
    'You do not have access to this issue: {auditBatchUuid}',
  'cashflowDomain.priceAudit.details.page.completed':
    'This issue has been reviewed. Would you like to review the next one?',
  'cashflowDomain.priceAudit.details.page.error.action.label.go.back': 'Go Back',
  'cashflowDomain.priceAudit.details.page.error.action.label.review.next': 'Review Next',
  'cashflowDomain.priceAudit.header.title': 'Issue #{auditBatchUuid}',
  'cashflowDomain.priceAudit.header.button.exit': 'Exit',
  'cashflowDomain.priceAudit.header.button.resolve': 'Resolve',
  'cashflowDomain.priceAudit.item.details.copyToClipboard': 'Copied to clipboard!',
  'cashflowDomain.priceAudit.item.details.title.item.details': 'Item Details',
  'cashflowDomain.priceAudit.item.details.title.order.summary': 'Order Summary',
  'cashflowDomain.priceAudit.item.details.label.cost.unit': 'Cost unit',
  'cashflowDomain.priceAudit.item.details.label.unit.price': 'Unit price',
  'cashflowDomain.priceAudit.item.details.label.loyalty.price': 'Loyalty price',
  'cashflowDomain.priceAudit.item.details.label.sale.price': 'Sale price',
  'cashflowDomain.priceAudit.item.details.label.store': 'Store',
  'cashflowDomain.priceAudit.item.details.label.order.created.at': 'Created at',
  'cashflowDomain.priceAudit.item.details.label.order.fulfilled.at': 'Delivered at',
  'cashflowDomain.priceAudit.item.details.label.order.id': 'Order id',
  'cashflowDomain.priceAudit.item.details.label.item.price.on.receipt': 'Item price on receipt',
  'cashflowDomain.priceAudit.item.details.label.overspend': 'Overspend',
  'cashflowDomain.priceAudit.item.details.label.upstreamClassifications':
    'Upstream classifications',
  'cashflowDomain.priceAudit.item.details.upstreamClassifications.price.price.greater':
    'Incorrect Price (In-Store Higher): The price charged in-store is higher than the Instacart order price.',
  'cashflowDomain.priceAudit.item.details.upstreamClassifications.price.ic.greater':
    'Incorrect Price (Instacart Higher): The Instacart order price is higher than the price charged in-store.',
  'cashflowDomain.priceAudit.item.details.upstreamClassifications.weight.iccatalog.weight':
    'Incorrect Weight (POS < Order): The Instacart Catalog is measured in weight, but the POS is measured in quantity.',
  'cashflowDomain.priceAudit.item.details.upstreamClassifications.weight.iccatalog.qty':
    'Incorrect Weight (POS < Order): The Instacart Catalog is measured in quantity, but the POS is measured in weight.',
  'cashflowDomain.priceAudit.item.details.upstreamClassifications.weight.iccatalogwgt_posqty':
    'Incorrect Weight (POS > Order): The Instacart Catalog is measured in weight, but the POS is measured in quantity.',
  'cashflowDomain.priceAudit.item.details.upstreamClassifications.weight.iccatalogqty.posweight':
    'Incorrect Weight (POS > Order): The Instacart Catalog is measured in quantity, but the POS is measured in weight.',
  'cashflowDomain.priceAudit.priceComparison.table.noResults': 'No Price History Found',
  'cashflowDomain.priceAudit.priceComparison.table.title.catalog': 'Published Catalog Item History',
  'cashflowDomain.priceAudit.priceComparison.table.title.retailer': 'Data Sent from Retailer',
  'cashflowDomain.priceAudit.priceComparison.table.column.timestamp': 'Timestamp',
  'cashflowDomain.priceAudit.priceComparison.table.column.costUnit': 'Cost Unit',
  'cashflowDomain.priceAudit.priceComparison.table.column.price': 'Price',
  'cashflowDomain.priceAudit.priceComparison.table.column.loyaltyPrice': 'Loyalty Price (Dates)',
  'cashflowDomain.priceAudit.priceComparison.table.column.salePrice': 'Sale Price (Dates)',
  'cashflowDomain.priceAudit.error.message.json.parsing.error':
    'Error parsing cashflow audit input data',
  'cashflowDomain.priceAudit.error.message.json.parsing.metadata': 'Invalid batch metadata',

  // Spread Landing Page
  'cashflowDomain.spread.title': 'Cash flow',
  'cashflowDomain.spread.refresh': 'Refresh',
  'cashflowDomain.spread.startAudit': 'Start Audit',
  'cashflowDomain.spread.errorTitle': 'Error',
  'cashflowDomain.spread.errorBodyNoBatch': 'There are no issues to review',
  'cashflowDomain.spread.workflow.title': 'New Issues',

  // Spread Details Page
  'cashflowDomain.spread.details.header.title': 'Issue #{riskIssueId}',
  'cashflowDomain.spread.details.header.button.exit': 'Exit',
  'cashflowDomain.spread.details.header.button.resolve': 'Resolve',
  'cashflowDomain.spread.details.order.title': 'Order',
  'cashflowDomain.spread.details.order.more': 'More',
  'cashflowDomain.spread.details.order.total': 'Est. total (actual total)',
  'cashflowDomain.spread.details.order.overspend': 'Overspend',
  'cashflowDomain.spread.details.order.type': 'Type',
  'cashflowDomain.spread.details.order.chat': 'Customer/Shopper chat',
  'cashflowDomain.spread.details.order.contactHistory': 'Care contact history',
  'cashflowDomain.spread.details.order.careContact': 'Care Contact',

  // Resolve Issue Modal Form
  'cashflowDomain.priceAudit.resolve.issue.form.title': 'Resolve Issue',
  'cashflowDomain.priceAudit.resolve.issue.form.entry.title': 'Cause of Discrepancy',

  'cashflowDomain.priceAudit.resolve.issue.form.label.discrepancy.type': 'Discrepancy Type',
  'cashflowDomain.priceAudit.resolve.issue.form.label.discrepancy.type.required':
    'Discrepancy type is required',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.price': 'Correct Price',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.price.required':
    'Correct price is required',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.price.type': 'Price Type',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.price.type.required':
    'Price type is required',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.cost.unit': 'Correct Cost Unit',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.cost.unit.required':
    'Correct cost unit is required',
  'cashflowDomain.priceAudit.resolve.issue.form.label.notes': 'Notes',
  'cashflowDomain.priceAudit.resolve.issue.form.label.optional': ' (optional)',
  'cashflowDomain.priceAudit.resolve.issue.form.price.validator.invalidFormat':
    'Price must be a valid number with up to 2 decimal places',
  'cashflowDomain.priceAudit.resolve.issue.form.price.validator.lessThanZero':
    'Price must be greater than 0',

  // Discrepancy types -- labels and descriptions
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceRetailerData.label':
    'Price: retailer data was incorrect',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceRetailerData.description':
    'Incorrect base, loyalty or sales price provided in retailer data.',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceProcessing.label':
    'Price: altered in processing',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceProcessing.description':
    'Retailer provided the correct price, but the published catalog item price was different.',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceChangedAfterOrderPlacement.label':
    'Price: changed after order placement',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceChangedAfterOrderPlacement.description':
    'Price was correct at the time order was placed, but retailer price changed before order fulfillment.',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.costUnitRetailerData.label':
    'Cost unit: retailer data was incorrect',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.costUnitRetailerData.description':
    'Incorrect cost unit provided in retailer data: weighted instead of "each," or "each" instead of weighted.',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.costUnitProcessing.label':
    'Cost unit: altered in processing',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.costUnitProcessing.description':
    'Retailer provided the correct cost unit, but the published catalog item cost unit was different.',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.costUnitChangedAfterOrderPlacement.label':
    'Cost unit: changed after order placement',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.costUnitChangedAfterOrderPlacement.description':
    'Cost unit was correct at the time order was placed, but retailer cost unit changed before order fulfillment.',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceTypeMismatch.label':
    'Price: type mismatch',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.priceTypeMismatch.description':
    'Catalog data correct, but different price types used for customer and retailer (e.g., loyalty price applied for customer but not in store).',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.noDiscrepancy.label':
    'No Discrepancy',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.noDiscrepancy.description':
    'Catalog item price and in-store price match.',

  'cashflowDomain.priceAudit.resolve.issue.form.cost.unit.options.each': 'Each',
  'cashflowDomain.priceAudit.resolve.issue.form.cost.unit.options.lb': 'Pound (lb)',
  'cashflowDomain.priceAudit.resolve.issue.form.cost.unit.options.kg': 'Kilogram (kg)',
  'cashflowDomain.priceAudit.resolve.issue.form.correct.price.type.options.base': 'Base',
  'cashflowDomain.priceAudit.resolve.issue.form.correct.price.type.options.loyalty': 'Loyalty',
  'cashflowDomain.priceAudit.resolve.issue.form.correct.price.type.options.sales': 'Sales',
  'cashflowDomain.priceAudit.resolve.issue.form.correct.price.type.options.unknown': 'Unknown',
  'cashflowDomain.priceAudit.resolve.issue.form.submit.button': 'Submit and view next',
  'cashflowDomain.priceAudit.resolve.issue.form.submit.duplicate.error':
    'Cannot submit with duplicate discrepancy type',
} as const

export default EN_US
